import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'CHECKLISTS',
    itemActionName: 'CHECKLIST_ITEM',
});
